var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgExpertHired = function SvgExpertHired(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#4CD964",
    rx: 8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L9.6 0 9.6 9.6 0 9.6z",
    transform: "translate(3.2 3.2)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M4.025.492c1.038-.324 1.662.22 1.653 1.374-.002.21-.012.395-.032.676-.041.58-.038.746.007.82.005.008.012.013.067.022.115.02.303.009.57-.042.158-.03.318-.065.495-.107.077-.018.648-.158.796-.19.29-.064.5-.09.693-.079.557.035.861.407.91 1.067.078 1.058-.161 3.164-.403 3.951-.26.85-.74 1.188-1.813 1.207-.65.011-1.65.011-3.007 0-.488-.012-.918-.136-1.281-.372-.14.228-.392.38-.68.38h-.8c-.442 0-.8-.358-.8-.8V4c0-.441.358-.8.8-.8H2c.279 0 .525.143.668.36.58-.786.94-1.697 1.08-2.738.02-.154.129-.282.277-.329zM2 4h-.8v4.4H2V4zm2.569-2.803l-.07.005c-.238 1.391-.844 2.583-1.814 3.566l.115-.123v3.228c.256.296.583.463.997.507l.177.012c1.344.011 2.338.011 2.98 0 .737-.013.906-.133 1.063-.642.212-.692.44-2.699.369-3.658-.022-.29-.045-.319-.162-.326-.1-.007-.25.013-.473.061-.135.03-.697.168-.783.188-.187.044-.358.081-.528.114-.75.143-1.222.061-1.472-.352-.174-.29-.178-.476-.12-1.29.02-.267.028-.438.03-.626.004-.523-.083-.696-.379-.66z",
    transform: "translate(3.2 3.2)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgExpertHired);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "expert-hired.7e0a410c4c3252cd5dc86fc056b09bec.svg";